<template>
  <div id="gwi-myPayDetail" class="app">
    <scroll class="scroll-height" @refresh="refresh">
      <section class="thick">
        <dl class="field">
          <dt>医院</dt>
          <dd>{{ hospitalName }}</dd>
        </dl>
        <dl class="field">
          <dt>姓名</dt>
          <dd>{{ param.queryParam.holderName }}</dd>
        </dl>
        <dl class="field">
          <dt>卡号</dt>
          <dd>{{param.queryParam.cardNo}}
          </dd>
        </dl>
        <dl class="field">
          <dt>时间</dt>
          <dd>{{ param.queryParam.orderTime | formatpayDate }}</dd>
        </dl>
      </section>
      <div
        :id="'myPayDetail-payDetail-' + index"
        v-for="(item, index) in payDetailList"
        :key="index"
      >
        <section class="thick mythick">
          <div class="title" @click="showDetail(item)">
            <span class="f-strong">{{ item.recipeName }}</span>
            <div class="mytitle">
              <span class="f-strongest">{{ param.queryParam.fee | formatFee }}</span>
              <span v-show="!item.showDetailInfo" class="arr-gray-down"></span>
              <span v-show="item.showDetailInfo" class="arr-gray-up"></span>
            </div>
          </div>
          <div v-if="item.items.length > 0" v-show="item.showDetailInfo">
            <div
              v-for="subItem in item.items"
              :key="subItem.item"
              class="report-detail"
            >
              <div class="field myfield">
                <div>
                  <label>{{ subItem.itemName }}</label>
                </div>
              </div>
              <div class="report-table-container">
                <table class="report-table">
                  <tr>
                    <td class="f-minor">单价</td>
                    <td class="f-minor">数量</td>
                    <td class="f-minor">总价</td>
                  </tr>
                  <tr>
                    <td>{{ subItem.itemFee | formatFee(false) }}</td>
                    <td>{{ subItem.itemQty | formatItemQty }}</td>
                    <td>
                      {{ (subItem.itemFee * subItem.itemQty) | formatFee }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </scroll>
    <footer>
      <div  class="goPay">
        <span>总金额</span>
        <span class="f-strongest">{{ param.queryParam.fee | formatFee }}</span>
      </div>
    </footer>
  </div>
</template>
<script>
import queryFun from 'queryFunList.service'
export default {
  methods: {
    refresh () {
      this.messagePush();
      var postParam = this.param.queryParam;
      this.isClinicPay = this.param.isClinicPay;
      postParam.orderId = this.param.queryParam.orderId;
      var today = new Date();
      postParam.endDate = postParam.endDate || today.format('yyyy-MM-dd');
      today.setMonth(today.getMonth() - 3);
      postParam.startDate = postParam.startDate || today.format('yyyy-MM-dd');
      queryFun.getCostDetail(postParam).then((res) => {
        if (res.resultCode=== this.constant.RESULT_SUCCESS) {
          var result = res.data;
          if (result.length > 0) {
            for (var i = 0; i < result.length; i++) {
              result[i].showDetailInfo = false;
            }
            this.payDetailList = result;
            this.hospitalName = result[0].hospitalName;
          }

        }
      });
    },
    messagePush () {
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.orderId) {
        //消息推送情况下，将需要的参数取下来保存至this.param.queryParam
        const geturlParam = {
          "visitName": query.visitName,
          "doctName": query.doctName,
          "holderName": query.holderName,
          "cardType": query.cardType,
          "cardNo": query.cardNo,
          "orderId": query.orderId,
          "orderTime": query.orderTime,
          "fee": query.fee,
        };
        this.param.queryParam = geturlParam;
        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        http.headers.common['hospitalId'] = hospital.hospitalId;
      } else {
        this.param.queryParam = this.$store.state.paramModule.param.HospitalCostList.queryParam;
      }
    },
    showDetail (item) {
      item.showDetailInfo = !item.showDetailInfo;
    },
    finished: function () {
      this.$router.replace('/');
    }
  },
  data () {
    return {
      payDetailList: [],
      orderId: '',
      hospitalName: '',
      isClinicPay: false,
      param: {
        queryParam: {
        }
      },
    }
  },
  created () {
    this.refresh();
  }
}
</script>
<style lang="scss">
.scroll-height {
  margin-bottom: 1.8rem;
}
.mythick {
  margin-bottom: 0 !important;
}
.mytitle {
  float: right;
  padding-right: 1rem;
}
.myfield {
  background: #f8f8f8;
}
.goPay {
  height: 1.8rem;
  background-color: #fff;
  width: 100%;
  font-size: 0.9rem;
  line-height: 1.8rem;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// HospitalCostListDetail.vue?660d6bff